module.exports = __webpack_public_path__ + "img/27.6a22634b.jpg";